import { Link, useRouterState } from "@tanstack/react-router";
import { getMobileBottomNavSlots } from "@/lib/firm-primary-nav";
import { hapticLight } from "@/lib/native/haptics";

/** Instagram-style 5-tab phone chrome — Home · Sell · Stock · Make · Money. */
export function MobileBottomNav() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const slots = getMobileBottomNavSlots();

  return (
    <nav className="mobile-bottom-nav" data-device-chrome="phone" aria-label="Primary navigation">
      {slots.map((slot) => {
        const active = slot.match(pathname);
        const Icon = slot.icon;
        return (
          <Link
            key={slot.id}
            to={slot.to as never}
            search={(slot.search ?? undefined) as never}
            onClick={() => void hapticLight()}
            className={`mobile-bottom-nav__item ${active ? "is-active" : ""}`}
            aria-current={active ? "page" : undefined}
          >
            <Icon aria-hidden="true" />
            <span className="max-w-full px-0.5 text-center leading-tight break-words whitespace-normal">
              {slot.word}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
